import {
    ACC_CORP_LOGO_VIEW_RESET,
    ACC_CORP_LOGO_VIEW,
    ACC_CORP_LOGO_VIEW_SUCCESS,
    ACC_CORP_LOGO_VIEW_FAIL,
    ACC_CORP_LOGO_VIEW_REFRESH,
} from './constants';

//
export const AccountCorpLogoViewReducer = (state = {}, action) => {
    let ret = {
        ...state,
        idKey: Math.random()
    }
    const data = action.payload;
    switch (action.type) {
        case ACC_CORP_LOGO_VIEW_RESET:
            ret.loading = false;
            ret.refresh = false;
            ret.loadSuccess = null;
            ret.error = null;
            ret.blobUrl = null;
            break;
        case ACC_CORP_LOGO_VIEW_REFRESH:
            ret.refresh = true;
            break;
        case ACC_CORP_LOGO_VIEW:
            ret.loading = true;
            ret.refresh = false;
            ret.loadSuccess = null;
            ret.error = null;
            break;
        case ACC_CORP_LOGO_VIEW_SUCCESS:
            ret.loading = false;
            ret.loadSuccess = true;
            ret.blobUrl = data.blobUrl;
            break;
        case ACC_CORP_LOGO_VIEW_FAIL:
            ret.loading = false;
            ret.loadSuccess = false;
            ret.error = data;
            break;
        default:
            return {...state};
    }
    return ret;
}